import Dayjs from 'dayjs';

const DelinquencyPopoverContent = props => {
    const {
        // role,
        row
    } = props;

    return (
        <div>

            <div><strong><i>Unit #:</i></strong> {row.bldg_unit}</div>
            <div><strong><i>Name:</i></strong> {row.resident_name}</div>
            <div>
                <strong><i>Lease Status:</i></strong> {row.lease_status}
                {row.data.special_status && <div><strong><i>Special-status:</i></strong> {row.data.special_status}</div>}
                {row.lease_sub_status && <div><strong><i>Sub-status:</i></strong> {row.lease_sub_status} </div>}
            </div>
            <div>
                <strong><i>Current due:</i></strong> ${row.total_current_due}
                <div><strong><i>Past due: </i></strong>${row.total_past_due}</div>
                <div><strong><i>Total delinquent:</i></strong> ${row.total_delinquent.toFixed(2)}</div>
            </div>
            <div><strong><i>Payment Status: </i></strong> {row.payment_status}</div>
            <div><strong><i>Scheduled Rent: </i></strong> {row.scheduled_rent}</div>
            {row.data.manager_notes && <div><strong><i>Manager Notes: </i></strong> {row.data.manager_notes}</div>}
            {row.data.hold_date && <div><strong><i>Hold Date: </i></strong> {Dayjs(row.data.hold_date).format('MM/DD/YYYY').toString()}</div>}
            {row.data.held_by && <div><strong><i>Held By: </i></strong> {row.data.held_by}</div>}
            {row.data.admin_notes && <div><strong><i>Admin Notes: </i></strong> {row.data.admin_notes}</div>}
            {row.data.general_notes && <div><strong><i>General Notes: </i></strong> {row.data.general_notes}</div>}
            {row.data.court_registry && <div><strong><i>Court Registry: </i></strong> {row.data.court_registry}</div>}
            {row.data.three_day_served && <div><strong><i>Three Day Served: </i></strong> {Dayjs(row.data.three_day_served).format('MM/DD/YYYY').toString()}</div>}
            {row.data.file_date && <div><strong><i>File Date: </i></strong> {Dayjs(row.data.file_date).format('MM/DD/YYYY').toString()}</div>}
            {row.data.case_number && <div><strong><i>Case #: </i></strong> {row.data.case_number}</div>}
            {row.data.summons_served && <div><strong><i>Summons Served: </i></strong> {Dayjs(row.data.summons_served).format('MM/DD/YYYY').toString()}</div>}
            {row.data.default_date && <div><strong><i>Default Date: </i></strong> {Dayjs(row.data.default_date).format('MM/DD/YYYY').toString()}</div>}
            {row.data.motion_to_strike && <div><strong><i>Motion To Strike: </i></strong> {Dayjs(row.data.motion_to_strike).format('MM/DD/YYYY').toString()}</div>}
            {row.data.judgement && <div><strong><i>Judgement: </i></strong> {Dayjs(row.data.judgement).format('MM/DD/YYYY').toString()}</div>}
            {row.data.writ_of_possession && <div><strong><i>Writ Of Possession: </i></strong> {Dayjs(row.data.writ_of_possession).format('MM/DD/YYYY').toString()}</div>}
            {row.data.twentyfour_hour_notice && <div><strong><i>24hr Notice: </i></strong> {Dayjs(row.data.twentyfour_hour_notice).format('MM/DD/YYYY').toString()}</div>}
            {row.data.initial_payment && <div><strong><i>Initial Payment: </i></strong> ${row.data.initial_payment}</div>}
            {row.data.balance && <div><strong><i>Balance: </i></strong> ${row.data.balance}</div>}
            {row.data.stipulation_signed_date && <div><strong><i>Stip Signed Date: </i></strong> {Dayjs(row.data.stipulation_signed_date).format('MM/DD/YYYY').toString()}</div>}
        </div>
    );
};

export default DelinquencyPopoverContent;
